module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAYAAAA/ZK6/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADpSURBVHgBpVLRDYMgEIWm/2UEukFHYIVu4AZlA12hEziKI2gnwA1sJ6BH+0guiEjiJU/weO/gHQhxJLz3D4Lz/whjWyI3IBn8a8JI6LYEYySznEIRFXMnth6SjguklG9MLznBTLgmO2gaAj4icySD7W9VHkBqWJcWghVHQ1KVAeesifuZPi/CRHgWiIbQUtemaHYpkAOnD/54Ykgvja1pNEHzpIWXnCB0rk+TCm1UGYHj1X83jScQTNu0Og0zrc+5rVe7wFsjtgIEy8w6UQq0eMC8X5ndEC3sIeoaQQfyfnUIonkjaqN0lC/XVQg/kRtvKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/player-icon.png
// module id = 67
// module chunks = 0